<template>
	<span v-if="category" class="text-xs uppercase text-gray-500 lg:text-base">{{ category }}</span>
	<h2 v-if="range" class="mb-10 border-b-2 border-b-stone-600 text-xl lg:text-3xl">
		{{ range }}
	</h2>

	<h1 class="text-2xl uppercase lg:text-5xl">
		{{ name }}<span v-if="itemsPerPack > 1"> (set of {{ itemsPerPack }})</span>
	</h1>
	<div v-if="description" v-html="description" class="prose mb-4"></div>
	<p v-if="code"><span class="font-bold">Product code: </span>{{ code }}</p>
</template>

<script>
export default {
	name: "IntProductInfo",

	props: {
		name: {
			type: String,
			required: true,
		},
		code: {
			type: String,
			required: true,
		},
		category: {
			type: String,
		},
		range: {
			type: String,
		},
		description: {
			type: String,
		},
		itemsPerPack: {
			type: Number,
			default: 0,
		},
	},
}
</script>
